import { resolveScheduleVisitTypeSlug } from "../models/schedule-visit-types";

export const GAE_PROCEDURE_SERVICE_NAME = "gae procedure";

export function isGaeProcedureServiceName(serviceDisplayName: string): boolean {
  return (
    String(serviceDisplayName ?? "")
      .trim()
      .toLowerCase() === GAE_PROCEDURE_SERVICE_NAME
  );
}

export function isProcedureScheduleVisitType(visitTypeRaw: string): boolean {
  return resolveScheduleVisitTypeSlug(String(visitTypeRaw ?? "")) === "procedure";
}

/** GAE Procedure + Procedure visit type — eligible for booked / achieved journey_log rows. */
export function isGaeProcedureJourneyLogEligible(
  visitTypeRaw: string,
  serviceDisplayName: string
): boolean {
  return (
    isProcedureScheduleVisitType(visitTypeRaw) &&
    isGaeProcedureServiceName(serviceDisplayName)
  );
}
